import { useState, useEffect, useRef } from "react";
import { url, verifyUserSession } from "../config";
import Dashboard from "./Dashboard";
import bgImage from "../assets/bgStreetlight.jpeg";
import bcLogo from "../assets/BrightCity-logo-og.png";
import ResetPasswordModal from "./ResetPassword";
import toast from "../utils/toast";
import { getAppVersion } from './../modules/Mobile/helper/Appversion';

export default function Login() {
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);

  const [otp, setOtp] = useState("");
  const [loginType, setLoginType] = useState(null);
  const [mobileVerified, setMobileVerified] = useState(false);

  const [otpTimer, setOtpTimer] = useState(0);
  const [totalTime, setTotalTime] = useState(0);
  const [otpExpired, setOtpExpired] = useState(false);
  const [otpAttemptsExceeded, setotpAttemptsExceeded] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const timerRef = useRef(null);
  const [appVersion, setAppVersion] = useState();

  console.log(appVersion, ">>>>>>>>>>");

  useEffect(() => {
    const checkSession = async () => {
      const authKey = localStorage.getItem("authKey");
      const forceReset = localStorage.getItem("resetPassword");
      const version = await getAppVersion();
      setAppVersion(version);
      if (!authKey) return;

      if (forceReset === "1") {
        setShowResetModal(true);
        return;
      }

      const result = await verifyUserSession(authKey);

      if (result.success) {
        setIsLoggedIn(true);
      } else {
        logoutUser();
      }
    };


    checkSession();
  }, []);

  const resetLoginState = () => {
    // Input fields
    setPassword("");
    setOtp("");

    // Login flow
    setLoginType(null);
    setMobileVerified(false);
    setOtpSent(false);

    // Timer
    clearInterval(timerRef.current);
    timerRef.current = null;
    setOtpTimer(0);
    setTotalTime(0);

    // OTP states
    setOtpExpired(false);
    setotpAttemptsExceeded(false);

    // UI
    setLoading(false);
    setErrorMsg("");
  };


  const checkLoginType = async () => {
    resetLoginState();
    const appVersion = await getAppVersion();
    if (!/^\d{10}$/.test(mobile)) {
      setErrorMsg("Enter a valid mobile number");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          workforce: "getLoginType",
          mobile,
          appVersion
        }),
      });

      const data = await res.json();

      if (data.Result === 1) {
        setLoginType(Number(data.logintype));
        setMobileVerified(true);
        setOtpSent(true);
        if (Number(data.logintype) === 2 || Number(data.logintype) === 3) {
          toast(data.message, 'success');
          const duration = data.allowedTime || 0;
          startOtpTimer(duration);
          setTotalTime(duration);
        }

        // Optional:
        // if OTP is enabled, backend can send OTP here
      } else {
        setErrorMsg(data.errMsg);
      }
    } catch (e) {
      setErrorMsg("Unable to connect.");
    }

    setLoading(false);
  };

  const startOtpTimer = (duration) => {
    clearInterval(timerRef.current);

    setOtpTimer(duration);
    setOtpExpired(false);

    timerRef.current = setInterval(() => {
      setOtpTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          setOtpExpired(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleLogin = () => {
    setErrorMsg("");

    // OTP only login
    if (Number(loginType) === 2) {
      return verifyOtpLogin();
    }

    // Password only login
    if (Number(loginType) === 1) {
      return verifyPassword();
    }

    // Both allowed
    if (Number(loginType) === 3) {
      if (otp && !password) return verifyOtpLogin();
      if (password && !otp) return verifyPassword();

      if (!otp || !password) {
        setErrorMsg("Enter OTP or Password");
        return;
      }

      // choose rule (you can change this)
      return verifyOtpLogin(); // or loginUser()
    }
  };

  const verifyOtpLogin = async () => {
    setLoading(true);

    try {
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          workforce: "verifyOTP",
          mobile,
          otp,
        }),
      });

      const data = await res.json();

      if (data.Result === 1) {
        localStorage.setItem("authKey", data.authKey);
        localStorage.setItem("mobile", mobile);

        const result = await verifyUserSession(data.authKey);

        if (result.success) {
          setIsLoggedIn(true);
        } else {
          setErrorMsg("Session verification failed");
          logoutUser();
        }
      } else if (data.Result === 4) {
        setotpAttemptsExceeded(true);
        setErrorMsg(data.msg);
      } if (data.Result === 3) {
        // localStorage.setItem("authKey", data.authKey);
        localStorage.setItem("resetPassword", "1");
        toast(data.msg);
        setShowResetModal(true);
      } else {
        setErrorMsg(data.msg || "OTP verification failed");
      }
    } catch (err) {
      setErrorMsg("Server error");
    }

    setLoading(false);
  };

  const resendOtp = async () => {
    setErrorMsg("");
    setLoading(true);

    // reset OTP state
    setOtp("");
    setOtpExpired(false);
    setotpAttemptsExceeded(false);
    setOtpTimer(0);
    setMobileVerified(false);
    setOtpSent(false);

    try {
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          workforce: "getLoginType",
          mobile,
        }),
      });

      const data = await res.json();

      if (data.Result === 1) {
        setLoginType(Number(data.logintype));
        setMobileVerified(true);
        setOtpSent(true);

        const duration = data.allowedTime || 0;
        setTotalTime(duration);
        startOtpTimer(duration);
      } else {
        setErrorMsg(data.errMsg);
      }
    } catch (e) {
      setErrorMsg("Unable to resend OTP.");
    }

    setLoading(false);
  };

  const verifyPassword = async () => {
    setErrorMsg(""); // reset previous error

    if (!mobile || mobile.length !== 10 || !/^\d{10}$/.test(mobile)) {
      setErrorMsg("Invalid Mobile number");
      return;
    }

    if (!password) {
      setErrorMsg("Invalid Password");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ workforce: "loginUser", mobile, password }),
      });

      const data = await res.json();

      if (data.Result === 1) {
        localStorage.setItem("authKey", data.authKey);
        localStorage.setItem("mobile", mobile);

        const result = await verifyUserSession(data.authKey);

        if (result.success) {
          setIsLoggedIn(true);
        } else {
          setErrorMsg("Session verification failed");
          logoutUser();
        }
      }
      if (data.Result === 3) {
        // localStorage.setItem("authKey", data.authKey);
        localStorage.setItem("resetPassword", "1");
        toast(data.data);
        setShowResetModal(true);
      } else {
        setErrorMsg(data.errMsg || "Login failed");
      }
    } catch (err) {
      setErrorMsg("Server error. Please try again.");
      console.error(err);
    }

    setLoading(false);
  }

  // const loginUser = async () => {
  //   setErrorMsg(""); // reset previous error

  //   if (!mobile || mobile.length !== 10 || !/^\d{10}$/.test(mobile)) {
  //     setErrorMsg("Invalid Mobile number");
  //     return;
  //   }

  //   if (password) {
  //     verifyPassword();
  //     return;
  //   }

  //   if(otp){
  //     verifyPassword();
  //     return;
  //   }
  // };

  const handleMobileChange = (e) => {
    setMobile(e.target.value);
    if (errorMsg) setErrorMsg("");
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (errorMsg) setErrorMsg("");
  };

  // Logout function
  const logoutUser = () => {
    // 1. Clear storage
    localStorage.clear();

    // 2. Auth state
    setIsLoggedIn(false);

    // 3. Login inputs
    setMobile("");
    setPassword("");

    // 4. OTP states
    setOtp("");
    setLoginType(null);
    setMobileVerified(false);

    setOtpTimer(0);
    setTotalTime(0);
    setOtpExpired(false);
    setotpAttemptsExceeded(false);

    // 5. UI states
    setErrorMsg("");
    setShowResetModal(false);

    // 6. Optional: reset loading
    setLoading(false);
    return;
  };
  if (isLoggedIn) {
    return <Dashboard onLogout={logoutUser} />;
  }

  return (

    <div className="login-page" style={{ backgroundImage: `url(${bgImage})` }}>
      <div className="login-card" style={{ position: "relative" }}>
        <div className="card-title">
          <img src={bcLogo} alt="BrightCity Logo" className="login-logo" />
        </div>
        {mobileVerified &&
          (loginType === 2 || loginType === 3) &&
          otpTimer > 0 && (
            <div
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                width: "36px",
                height: "36px",
                zIndex: 10
              }}
            >
              {/* SVG CIRCLE */}
              <svg width="36" height="36" style={{ position: "absolute", top: 0, left: 0 }}>
                <circle
                  cx="18"
                  cy="18"
                  r="14"
                  stroke="#e0e0e0"
                  strokeWidth="3"
                  fill="none"
                />

                <circle
                  cx="18"
                  cy="18"
                  r="14"
                  stroke={otpTimer <= 10 ? "red" : "#4caf50"}
                  strokeWidth="3"
                  fill="none"
                  strokeLinecap="round"
                  strokeDasharray={2 * Math.PI * 14}
                  strokeDashoffset={
                    2 * Math.PI * 14 * (1 - otpTimer / totalTime)
                  }
                  style={{ transition: "stroke-dashoffset 1s linear" }}
                />
              </svg>

              {/* CENTER TEXT */}
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "10px",
                  fontWeight: "bold",
                  position: "absolute",
                  top: 0,
                  left: 0,
                }}
              >
                {otpTimer}
              </div>
            </div>
          )}
        <div className="input-field icon-field">
          <i className="material-icons">phone</i>

          <input
            type="text"
            value={mobile}
            onChange={handleMobileChange}
            placeholder="Mobile Number"
          />
        </div>

        {mobileVerified && (loginType === 1 || loginType === 3) && (
          <div className="input-field icon-field">
            <i className="material-icons">lock</i>

            <input
              type="password"
              value={password}
              onChange={handlePasswordChange}
              placeholder="Password"
            />
          </div>
        )}

        {mobileVerified && (loginType === 2 || loginType === 3) && (
          <>
            {/* OTP INPUT */}

            {/* OTP INPUT */}
            <div className="input-field icon-field" style={{ flex: 1 }}>
              <i className="material-icons">vpn_key</i>
              <input
                type="text"
                value={otp}
                onChange={(e) => {
                  const val = e.target.value;

                  // allow only numbers + max 4 digits
                  if (/^\d{0,4}$/.test(val)) {
                    setOtp(val);
                  }
                }}
                placeholder="OTP"
                maxLength={4}
              />
            </div>


            {/* TIMER */}
            <div style={{ marginTop: "5px", fontSize: "14px" }}>

              {otpExpired && (
                <span style={{ color: "red" }}>OTP expired</span>
              )}
            </div>

            {/* RESEND BUTTON */}
            {/* {(otpExpired || otpAttemptsExceeded) && (
            <button
              className="btn-login"
              onClick={checkLoginType}
              disabled={loading}
              style={{ marginTop: "10px", background: "#ff9800" }}
            >
              RESEND OTP
            </button>
          )} */}
          </>
        )}
        <p className="red-text" style={{ marginTop: "6px", fontSize: "0.85rem" }}>{errorMsg}</p>
        {!mobileVerified && (
          <button
            className="btn-login"
            onClick={checkLoginType}
            disabled={loading || !mobile}
          >
            SEND
          </button>
        )}
        {mobileVerified &&
          otpSent &&
          !otpExpired &&
          !otpAttemptsExceeded && (
            <button
              className="btn-login"
              onClick={handleLogin}
              disabled={loading}
            >
              LOGIN
            </button>
          )}
        {mobileVerified &&
          (otpExpired || otpAttemptsExceeded) && (
            <button
              className="btn-login"
              onClick={resendOtp}
              disabled={loading}
              style={{ marginTop: "10px", background: "#ff9800" }}
            >
              RESEND OTP
            </button>
          )}
        {/* <div>{appVersion}</div> */}
      </div>
      <div className="app-version">
        Version: {appVersion}
      </div>

      {showResetModal && (
        <ResetPasswordModal onClose={() => { setShowResetModal(false); resetLoginState() }} mobile={mobile} />
      )}
    </div>
  );
}


